module.exports = __webpack_public_path__ + "img/demo6.6de56336.jpg";